import { useCallback, useEffect, useState } from 'react';

const useCookie = () => {
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const setCookie = useCallback((name: string, value: string | number | boolean = "", days: number) => {
    if (isClient) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = `${name}=${value}${expires}; path=/`;
    }
  }, [isClient]);

  const getCookie = useCallback((name: string) => {
    if (isClient) {
      const matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
      ));
      return matches ? matches[1] : undefined;
    }
    return undefined;
  }, [isClient]);

  const eraseCookie = useCallback((name: string) => {
    if (isClient) {
      document.cookie = `${name}=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
    }
  }, [isClient]);

  return { setCookie, getCookie, eraseCookie };
};

export default useCookie;